export default {
  LOAD_PACKAGES (state, payload) {
    state.packages = payload
  },
  LOAD_ALL_PACKAGES (state, payload) {
    state.allPragyaPackages = payload
  },
  LOAD_INSTITUTION (state, payload) {
    state.institution = payload
  },
  LOAD_PUBLIC_INSTITUTION (state, payload) {
    state.publicInstitution = payload
  },
  LOAD_ENABLED_FEATURES (state, payload) {
    state.enabledFeatures = payload
  },
  LOAD_INSTITUTION_LABELS (state, payload) {
    state.institutionLabels = payload
  },
  LOAD_INSTITUTION_TERM_MAP (state, payload) {
    state.termMapWithCutOffDate = payload
  },
  LOAD_PARTNER_INSTITUTIONS (state, payload) {
    state.partnerInstitutions = payload
  },
  LOAD_SELF_REGISTRATION_LINK (state, payload) {
    state.selfRegistrationLink = payload
  },
  LOAD_SELF_SIGNIN_LINK (state, payload) {
    state.selfSigninLink = payload
  }
}



// WEBPACK FOOTER //
// ./widgetSrc/app/institution/vuex/mutations.js